module.exports = __webpack_public_path__ + "static/media/CaslonGraD.3f57b9b0.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CaslonGraD.eot
// module id = 1799
// module chunks = 50